import { RoleUserModel } from '@/core/services/Token/model/TokenModel'

export class UserResellerTypeModel {
  id = ''
  name = ''
}
export class UserResellerModel {
  id = ''
  name = ''
  symbol = ''
  type: UserResellerTypeModel = new UserResellerTypeModel()
  typeId = ''
  deleted = false
}

export class UserCurrencyModel {
  id = ''
  name = ''
  symbol = ''
  coinDigits = 0
}

export class UserModel {
  id = ''
  resellerId: UserResellerModel = new UserResellerModel()
  name = ''
  lastName = ''
  countryCodeId = ''
  companyName = ''
  companyAddress = ''
  companyTown = ''
  zipCode = ''
  telephone = ''
  mobileTelephone = ''
  department = ''
  vat: string | null = null
  email = ''
  emailConfirmed = false
  currencyId = '' //UserCurrencyModel
  lastAccessedAt: Date | string = ''
  createdAt: Date | string = ''
  note = ''
  deleted = false
  sdi: string | null = null
}

export class UserEmailCompleteValidationModel {
  userId = ''
  token = ''
}

export class CountryDataModel {
  label = ''
  value = ''
}

export class ChangePasswordModel {
  oldPassword = ''
  newPassword = ''
  confirmPassword = ''
}

export class RoleUserResponseModel {
  userId = ''
  roleId: RoleUserModel = RoleUserModel.User
}
